module.exports = __webpack_public_path__ + "static/media/adult-adventure-aircraft.0eb6cb82.png";